var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 179,
    viewBox: "0 0 224 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.176,
    y: 71.0254,
    width: 8.31571,
    height: 40.747,
    fill: "url(#paint0_linear_502_28216)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.353 83.6382H108.106L116.353 88.7662V83.6382Z",
    fill: "#146B83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0128 34.4355H50.5196C52.7926 43.553 64.3522 62.6929 84.614 66.3124",
    stroke: "#3DACCA",
    strokeWidth: 3.88066,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.653 34.4355H174.146C171.873 43.553 160.314 62.6929 140.052 66.3124",
    stroke: "#3DACCA",
    strokeWidth: 3.88066,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.093 10H77.2411V21.6424H45.6414H43.25L43.7426 23.9825C45.0987 30.4235 49.1619 40.2052 55.8185 49.0136C62.2338 57.5028 71.2079 65.2812 82.7135 68.1391C88.9169 77.849 99.7902 84.287 112.167 84.287C124.544 84.287 135.417 77.849 141.621 68.1391C153.126 65.2812 162.1 57.5028 168.516 49.0136C175.172 40.2052 179.236 30.4235 180.592 23.9825L181.084 21.6424H178.693H147.093V10ZM147.093 25.5231V49.361C147.093 54.3175 146.061 59.0328 144.199 63.3037C152.928 60.1512 160.03 53.8064 165.42 46.674C170.964 39.3378 174.573 31.3282 176.213 25.5231H147.093ZM80.1351 63.3037C78.2735 59.0328 77.2411 54.3175 77.2411 49.361V25.5231H48.1212C49.761 31.3282 53.3705 39.3378 58.9145 46.674C64.3046 53.8064 71.4061 60.1512 80.1351 63.3037Z",
    fill: "url(#paint1_linear_502_28216)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.418,
    y: 4.5,
    width: 79.8308,
    height: 7.48414,
    rx: 3.74207,
    fill: "#F4A94F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.418 7.54883H152.249C152.249 9.99824 150.263 11.9839 147.814 11.9839H76.853C74.4036 11.9839 72.418 9.99824 72.418 7.54883Z",
    fill: "#D79546"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4543 104.842C94.4543 102.086 96.6882 99.8525 99.4438 99.8525H125.222C127.978 99.8525 130.212 102.086 130.212 104.842V111.772H94.4543V104.842Z",
    fill: "#D79546"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4543 105.812H130.212V111.772H94.4543V105.812Z",
    fill: "#F4A94F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3646 11.9849L77.6841 44.6933V51.0687L102.077 11.9849H97.3646Z",
    fill: "#48B8D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 11.9849L78.0654 55.4691L78.7584 58.6221L79.7286 61.5326L110.393 11.9849H105.681Z",
    fill: "#48B8D7",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.333 26L116.684 38.2893L129.716 38.6299L119.373 46.5657L123.076 59.0655L112.333 51.6808L101.589 59.0655L105.293 46.5657L94.9493 38.6299L107.982 38.2893L112.333 26Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.333 30.2422L115.674 39.6786L125.681 39.9401L117.739 46.0337L120.582 55.6318L112.333 49.9614L104.083 55.6318L106.927 46.0337L98.9848 39.9401L108.992 39.6786L112.333 30.2422Z",
    fill: "#F7AE57"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.25 114C73.25 112.895 74.1454 112 75.25 112H148.249C149.354 112 150.249 112.895 150.249 114V179H73.25V114Z",
    fill: "#7274E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 143C0.25 141.895 1.14543 141 2.25 141H70.25C71.3546 141 72.25 141.895 72.25 143V179H0.25V143Z",
    fill: "#7274E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.75 159C151.75 157.895 152.645 157 153.75 157H221.75C222.855 157 223.75 157.895 223.75 159V179H151.75V159Z",
    fill: "#7274E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.9399 33.9389L8.62269 27.863L3.30546 21.7871L0.303803 18.3571C0.137725 18.1674 0.39402 17.8713 0.560093 18.0611L5.87732 24.137L11.1945 30.2129L14.1962 33.6429C14.3623 33.8326 14.106 34.1287 13.9399 33.9389Z",
    fill: "url(#paint2_linear_502_28216)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M170.94 99.9389L165.623 93.863L160.305 87.7871L157.304 84.3571C157.138 84.1674 157.394 83.8713 157.56 84.0611L162.877 90.137L168.195 96.2129L171.196 99.6429C171.362 99.8326 171.106 100.129 170.94 99.9389Z",
    fill: "url(#paint3_linear_502_28216)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.2557 47.0102L35.7535 48.5021L34.2614 47L33.2602 47.9946L34.7518 49.4963L33.25 50.9883L34.2443 51.9898L35.7465 50.4979L37.2386 52L38.2398 51.0054L36.7482 49.5032L38.25 48.0117L37.2557 47.0102Z",
    fill: "#E6E6E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.256 74.0102L161.753 75.5021L160.261 74L159.26 74.9946L160.752 76.4963L159.25 77.9883L160.244 78.9898L161.747 77.4979L163.239 79L164.24 78.0054L162.748 76.5032L164.25 75.0117L163.256 74.0102Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.75 84L65.6341 85.6158L67.25 86.5L65.6341 87.3842L64.75 89L63.8659 87.3842L62.25 86.5L63.8659 85.6158L64.75 84Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M164.75 0L165.634 1.61584L167.25 2.5L165.634 3.38416L164.75 5L163.866 3.38416L162.25 2.5L163.866 1.61584L164.75 0Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_28216",
    x1: 112.333,
    y1: 71.0254,
    x2: 112.333,
    y2: 111.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C9CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3DACCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_28216",
    x1: 112.167,
    y1: 10,
    x2: 112.167,
    y2: 97.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E9DBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#3FAFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11758F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_28216",
    x1: 14.25,
    y1: 26,
    x2: 0.25,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_28216",
    x1: 171.25,
    y1: 92,
    x2: 157.25,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.0d41c50fc5c6389f02f07c296252189a.svg";
export { ForwardRef as ReactComponent };